import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Flex } from '@rebass/grid';
import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import RegisterPage from './components/pages/Register';
import Text from './components/atoms/Text';
import { LoadingProvider } from './context/loading';
import { AuthProvider, initialAuthState } from './context/auth';
import { getClientCredential } from './api/auth';
import Image from './components/atoms/Image';
import hkfewPosterImage from './assets/poster.jpeg';
import digitalPosterImage from './assets/digital_poster.jpeg';
import DigitalRegister from './components/pages/DigitalRegister';
import CreateGallery from './components/pages/CreateGallery';
import Info from './components/pages/Info';
import ReactPixel from 'react-facebook-pixel'

const authLocalStorageKeyPrefix = 'auth_chinese_clothing';

const Container = styled.div`
  background-color: #cfcfcf;
  height: 100%;
  width: 100%;
  flex-direction: ${ifProp('isHorizontal', 'row', 'column')};
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  position: fixed;
  display: flex;
`;

const ViewPort = styled(Flex)`
  flex-direction: column;
  max-width: 640px;
  width: 100%;
  height: 100%;
  margin: auto;
`;

const Poster = styled(Flex)`
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

const LoaderContainer = styled(Flex)`
  background: rgba(0, 0, 0, 0.6);
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`;


const getStoredAuth = () => {
  let storedAuth = null;
  if (localStorage.getItem(`${authLocalStorageKeyPrefix}`)) {
    try {
      storedAuth = JSON.parse(localStorage.getItem(`${authLocalStorageKeyPrefix}`));
    } catch (err) {
      storedAuth = null;
    }
  }
  return storedAuth;
};

const parseAuthData = (authData) => {
  const { id_token, ...remainData } = authData;
  return remainData;
};
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: getStoredAuth() || initialAuthState,
      loading: true,
      isHorizontal: (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight),
    };
  }

  setAuth = (newAuth) => {
    this.setState({ auth: newAuth });
    localStorage.setItem(`${authLocalStorageKeyPrefix}`, JSON.stringify(newAuth));
  }

  setLoading = (isLoading) => {
    this.setState({ loading: isLoading });
  }

  loadAuth = () => {
    const storedAuth = getStoredAuth();
    if (!(storedAuth && storedAuth.access_token)) {
      return getClientCredential()
        .then(({ data }) => {
          const parsedAuth = parseAuthData(data);
          this.setAuth(parsedAuth);
          return parsedAuth;
        });
    }
    return Promise.resolve(storedAuth);
  }

  handleScreenChange = () => {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    if (width > height) {
      this.setState({ isHorizontal: true });
    } else {
      this.setState({ isHorizontal: false });
    }
  }

  componentDidMount() {
    this.setLoading(false)
    const url = window.location.href;
    if (url.includes('digital56.html')) {
      const options = {
        autoConfig: true,
        debug: true,
      };
      ReactPixel.init('1081057119566502', null, options)
      ReactPixel.pageView();
      return window.location.replace('https://form.jotform.com/SnapPop/HKDQCNCDC_form');
    }
    Promise.resolve(this.loadAuth())
      .catch(err => alert(err.message))
    window.addEventListener('resize', this.handleScreenChange, true);
  }
  

  render() {
    const { auth, loading, isHorizontal } = this.state;
    const url = window.location.href;
    let poster;
    if (url.includes('hkfew')) {
      poster = hkfewPosterImage;
    } else if (url.includes('digital56_step2')) {
      poster = digitalPosterImage;
    }

    return (
      <AuthProvider value={{ auth, setAuth: this.setAuth }}>
        <LoadingProvider value={{ loading, setLoading: this.setLoading }}>
          <Container isHorizontal={isHorizontal}>
            {poster && <Poster>
              <Image src={poster} width= {isHorizontal ? "40vw" : "90vw"} style={{ maxHeight: '90vh', objectFit: 'contain' }} alt="poster" />
            </Poster>}
            <ViewPort>
              <Flex flex="1 1 0" justifyContent="center">
                <Switch>
                  <Route path='/registration/hkfew.html' exact render={RegisterPage} />
                  <Route path='/registration/digital56_step2.html' exact render={DigitalRegister} />
                  <Route path='/create_gallery' exact render={CreateGallery} />
                  <Route path='/info' exact render={Info} />
                </Switch>
              </Flex>
            </ViewPort>
            {loading && (
              <LoaderContainer>
                <Text fontType="primary" variant="h3" palette="white">Loading...</Text>
              </LoaderContainer>
            )}
          </Container>
        </LoadingProvider>
      </AuthProvider>
    );
  }
}

export default withRouter(App);
